import { prettyValue } from "../../js/utils/formatters";

export default function ArchiveBadge({ transaction, thread }) {
  if (transaction?.status && transaction.status !== "open") {
    const closed = transaction.status === "closed";
    return (
      <span className={`archive-badge${closed ? "" : " archive-badge--aside"}`}>
        {prettyValue(transaction.status)}
      </span>
    );
  }
  if (thread?.status === "archived") {
    return <span className="archive-badge">Thread archived</span>;
  }
  return null;
}
